import React from "react";
import Box from '@mui/material/Box';
import { COLORS } from "../../../assets/colors";
import Typography from '@mui/material/Typography';
import { NavLink } from "react-router-dom";
import { ROUTES_PATH } from "../../../utils/Consts";
import useMediaQuery from '@mui/material/useMediaQuery';

function HomeCategoriesUI({
    data
}) {
    const isMobile = useMediaQuery('(max-width:600px)');

    return (
        <Box sx={{
            flexDirection: 'column',
            padding: { xs: '40px 20px', sm: '40px 20px', md: '60px 40px', lg: '60px 80px', xl: '60px 120px' },
            textAlign: 'center',
            background: '#ffffff'
        }}>
            {/* Título principal */}
            <Typography 
                variant="h2" 
                component="h2"
                sx={{ 
                    color: '#d7b547',
                    fontFamily: 'Quicksand',
                    fontWeight: 'bold',
                    fontSize: { xs: '2.2rem', sm: '2.8rem', md: '3.5rem' },
                    marginBottom: '20px',
                    textShadow: '0 0 10px rgba(215, 181, 71, 0.4)'
                }}>
                Nuestras Categorías
            </Typography>
            
            {/* Subtítulo descriptivo */}
            <Typography 
                variant="body1" 
                component="p"
                sx={{ 
                    color: '#d7b547',
                    fontFamily: 'Quicksand',
                    fontSize: { xs: '1rem', sm: '1.1rem', md: '1.2rem' },
                    maxWidth: '900px',
                    margin: '0 auto 50px auto',
                    lineHeight: 1.6
                }}>
                Explora nuestra amplia selección de deliciosos productos artesanales, elaborados con los mejores ingredientes y el amor de siempre
            </Typography>

            {/* Grid de categorías */}
            <Box sx={{
                display: { xs: 'grid', sm: 'flex' },
                gridTemplateColumns: { xs: 'repeat(2, 1fr)' },
                flexWrap: { sm: 'wrap' },
                justifyContent: { sm: 'center' },
                gap: { xs: '16px', sm: '20px', md: '24px' },
                maxWidth: { xs: '100%', sm: '100%', md: '100%' },
                margin: '0 auto',
                padding: { xs: '0', sm: '0', md: '0' }
            }}>
                {data.map(category => (
                    <NavLink
                        to={`${ROUTES_PATH.CATEGORIES}/${category.id}`}
                        style={{ textDecoration: 'none' }}
                        key={category.id}>
                        <Box sx={{
                            width: { xs: '100%', sm: '180px', md: '220px' },
                            height: { xs: 'auto', sm: '240px', md: '280px' },
                            aspectRatio: { xs: '3/4', sm: 'unset' },
                            background: `linear-gradient(135deg, ${COLORS.primary} 0%, rgba(30, 58, 95, 0.95) 100%)`,
                            borderRadius: '20px',
                            border: '3px solid #d7b547',
                            cursor: 'pointer',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: { xs: '16px', sm: '20px', md: '24px' },
                            transition: 'all 0.3s ease',
                            boxShadow: '0px 6px 20px rgba(0, 0, 0, 0.4)',
                            position: 'relative',
                            overflow: 'hidden',
                            "&:hover": {
                                transform: 'translateY(-8px)',
                                boxShadow: '0px 12px 32px rgba(215, 181, 71, 0.4)',
                                border: '3px solid #e6c663'
                            }
                        }}>
                            {/* Contenedor de imagen con fondo semitransparente */}
                            <Box sx={{
                                width: '100%',
                                flex: 1,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                background: 'rgba(255, 255, 255, 0.1)',
                                borderRadius: '12px',
                                padding: { xs: '10px', sm: '12px', md: '16px' },
                                marginBottom: '12px',
                                overflow: 'hidden'
                            }}>
                                <img 
                                    src={category.image} 
                                    loading="lazy" 
                                    alt={category.name}
                                    style={{ 
                                        width: '100%', 
                                        height: '100%', 
                                        objectFit: 'contain',
                                        borderRadius: '8px'
                                    }} 
                                />
                            </Box>
                            
                            {/* Nombre de la categoría */}
                            <Typography 
                                variant="h6" 
                                component="h3"
                                sx={{
                                    fontFamily: 'Quicksand',
                                    color: '#ffffff',
                                    textAlign: 'center',
                                    fontWeight: 'bold',
                                    fontSize: { xs: '1rem', sm: '1.1rem', md: '1.2rem' },
                                    textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)'
                                }}>
                                {category.name}
                            </Typography>
                        </Box>
                    </NavLink>
                ))}
            </Box>
        </Box>
    )
}

export { HomeCategoriesUI }
